var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoVerificacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34.999,
    viewBox: "0 0 35 34.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5632",
    "data-name": "Grupo 5632",
    transform: "translate(-6803.107 2037.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4528",
    "data-name": "Trazado 4528",
    d: "M85.35,88.262a17.5,17.5,0,1,1-17.5-17.5,17.5,17.5,0,0,1,17.5,17.5",
    transform: "translate(6752.757 -2108.702)",
    fill: "#d1067f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4529",
    "data-name": "Trazado 4529",
    d: "M63.137,98.661a1.708,1.708,0,0,1-1.028-.81l-3.292-5.867A1.711,1.711,0,1,1,61.8,90.31l2.174,3.873L76.258,81.6a1.711,1.711,0,1,1,2.447,2.39L64.824,98.209a1.709,1.709,0,0,1-1.687.452",
    transform: "translate(6751.525 -2110.244)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoVerificacion);
export default __webpack_public_path__ + "static/media/icono_verificacion.bec3b863473a78c1f48f202592557459.svg";
export { ForwardRef as ReactComponent };